import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Header from '../../components/header';
import constants from '../../config/constants';
import { setUKCountry } from '../../../../services/signup-service';
import '../style.scss';
import '../access-selector/style.scss';

const UK_COUNTRIES = [
  { value: 'england', label: 'England' },
  { value: 'scotland', label: 'Scotland' },
  { value: 'wales', label: 'Wales' },
  { value: 'northern_ireland', label: 'Northern Ireland' },
];

const NHSCountrySelectorComponent = ({ location }) => {
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    document.body.setAttribute('data-new-authentication-component', 'true');
  }, []);
  const urlParams = new URLSearchParams(
    (location && location.search) || window.location.search
  );
  const product = urlParams.get('product') || 'sleepio';
  const redirectUrl = urlParams.get('redirect_url');
  const next = urlParams.get('next');
  const emailRedirect = urlParams.get('email_redirect');

  const handleContinue = () => {
    if (!selectedCountry) {
      return;
    }

    setUKCountry(selectedCountry.value);

    const params = new URLSearchParams();
    if (redirectUrl) {
      params.set('redirect_url', redirectUrl);
    }
    if (next) {
      params.set('next', next);
    }

    if (selectedCountry.value === 'england') {
      document.cookie = `sl-user-flow=/${product}/nhs-england; SameSite=Strict; Path=/`;
      params.set('nhs_england', 'true');
    } else {
      if (
        emailRedirect &&
        emailRedirect.startsWith('/') &&
        !emailRedirect.startsWith('//')
      ) {
        // emailRedirect is constrained to same-origin paths: startsWith('/') && !startsWith('//')
        // rules out protocol-relative URLs (//evil.com) and absolute URLs.
        // codeql[js/client-side-unvalidated-url-redirection] codeql[js/xss]
        window.location.replace(emailRedirect);
        return;
      }
      params.set('nhs_email_path', 'true');
    }

    const qs = params.toString() ? `?${params.toString()}` : '';
    window.location.assign(`/login-component/login${qs}`);
  };

  return (
    <div className={`${product} login-component-container`}>
      <Header
        backgroundColor={
          constants.product[product] && constants.product[product].color
        }
        product={product}
        redirectURL={next}
        variant="signup"
      />
      <div id="sl-login-page">
        <form id="sl-login" name="sl-login" onSubmit={e => e.preventDefault()}>
          <div className="sl-access-selector">
            <h1 className="sl-access-selector__title">Where do you live?</h1>
            <div className="sl-access-selector__options">
              {UK_COUNTRIES.map(({ value, label }) => (
                <div
                  key={value}
                  className={
                    'sl-access-selector__option' +
                    (selectedCountry && selectedCountry.value === value
                      ? ' sl-access-selector__option--selected'
                      : '')
                  }
                  onClick={() => setSelectedCountry({ value, label })}
                  data-testid={`country-option-${value}`}
                >
                  <input
                    type="checkbox"
                    className="sl-access-selector__checkbox"
                    id={`country-option-${value}`}
                    checked={
                      !!(selectedCountry && selectedCountry.value === value)
                    }
                    onChange={() => setSelectedCountry({ value, label })}
                    tabIndex={-1}
                  />
                  <span
                    className="sl-access-selector__check-icon"
                    aria-hidden="true"
                  />
                  <span className="sl-access-selector__option-text">
                    {label}
                  </span>
                </div>
              ))}
            </div>
            <div className="sl-new-login-button-wrapper">
              <button
                type="button"
                className="sl-new-login-button sl-access-selector__continue"
                disabled={!selectedCountry}
                onClick={handleContinue}
                data-testid="country-selector-continue"
              >
                Continue
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

NHSCountrySelectorComponent.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
};

NHSCountrySelectorComponent.defaultProps = {
  location: null,
};

export default NHSCountrySelectorComponent;
